export const SALARY_CALCULATOR_SLUGS = ["berkalkulator", "salarycalculator", "calculatorsalariu"] as const;

export type SalaryCalculatorSlug = typeof SALARY_CALCULATOR_SLUGS[number];
export type CalculatorRegion = "hu" | "ro";

export function getCalculatorRegion(): CalculatorRegion {
	const region = useRuntimeConfig().public.activeConfig.region;
	return region?.toUpperCase() === "RO" ? "ro" : "hu";
}

export function getSalaryCalculatorPath(locale: string): string {
	const urlList = useRuntimeConfig().public.activeConfig.salaryCalculator;

	if (urlList[locale]) {
		return urlList[locale];
	}

	const firstKey = Object.keys(urlList)[0];
	return urlList[firstKey];
}

export function isSalaryCalculatorSlug(slug: string): slug is SalaryCalculatorSlug {
	return (SALARY_CALCULATOR_SLUGS as readonly string[]).includes(slug);
}
